import { z } from "zod";

export const customerSchema = z
  .object({
    first_name: z
      .string({ message: "Enter First Name" })
      .min(2, "Please Enter First Name")
      .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabets and spaces."),
    middle_name: z.string().optional(),
    last_name: z.string().optional(),
    phone_no: z
      .string()
      .trim()
      .min(10, "Phone number must be 10 digits")
      .max(10, "Phone number must be 10 digits")
      .regex(/^[6-9]\d{9}$/, "Invalid phone number"),
    sameAsContact: z.boolean().optional(),
    whatsapp_number: z
      .string()
      .trim()
      .min(10, "Whatsapp number must be 10 digits")
      .max(10, "Whatsapp number must be 10 digits")
      .regex(/^[6-9]\d{9}$/, "Invalid phone number")
      .optional(),
    email: z.string().email("Enter a valid Email Address"),
    password: z
      .string()
      .min(8, "Password must be at least 8 characters long")
      .max(64, "Password must not exceed 64 characters")
      .regex(/(.*[A-Z])/, "Password must contain at least 1 uppercase letters")
      .regex(/(.*[a-z])/, "Password must contain at least 1 lowercase letters")
      .regex(/(.*\d)/, "Password must contain at least 1 numbers")
      .regex(
        /(.*[@$!%*?&#])/,
        "Password must contain at least 1 special characters (@$!%*?&)",
      ),
    state: z
      .string({ message: "State is required" })
      .min(2, "Enter Your State"),
    district: z
      .string({ message: "District is required" })
      .min(2, "Enter your Disctrict"),
    city: z
      .string({ message: "City is required" })
      .min(2, "Enter Your City/Town"),
    gender: z
      .string({ message: "Gender is required" })
      .min(2, "Select Your Gender"),
    address: z
      .string({ message: "Address is required" })
      .min(2, "Enter Your short Address"),
    pin: z
      .string({ message: "Pin is required" })
      .min(6, "Enter a valid Pin Code"),
    reffered_by: z
      .string({ message: "Employee Code is required!" })
      .min(4, "Employee Code is required")
      .transform((val) => (val === "" ? null : val)),
  })
  .refine(
    (data) =>
      data.sameAsContact ||
      (data.whatsapp_number && data.whatsapp_number.length === 10),
    {
      message: "WhatsApp number is required if not same as contact number",
      path: ["whatsapp_number"],
    },
  );

export const EditCustomerSchema = z.object({
  first_name: z
    .string()
    .min(2, "Please Enter your First Name")
    .regex(/^[a-zA-Z\s]+$/, "Name must only contain alphabets and spaces."),
  middle_name: z.string().optional(),
  last_name: z.string().optional(),
  phone_no: z
    .string()
    .trim()
    .min(10, "Phone number must be 10 digits")
    .max(10, "Phone number must be 10 digits")
    .regex(/^[6-9]\d{9}$/, "Invalid phone number"),
  whatsapp_number: z
    .string()
    .trim()
    .min(10, "Whatsapp number must be 10 digits")
    .max(10, "Whatsapp number must be 10 digits")
    .regex(/^[6-9]\d{9}$/, "Invalid phone number"),
  state: z.string({ message: "State is required" }).min(2, "Enter Your State"),
  gender: z
    .string({ message: "Gender is required" })
    .min(2, "Select Your Gender"),
  address: z
    .string({ message: "Address is required" })
    .min(2, "Enter Your short address"),
  district: z
    .string({ message: "District is required" })
    .min(2, "Enter your Disctrict"),
  city: z
    .string({ message: "City is required" })
    .min(2, "Enter Your City/Town"),
  pin: z
    .string({ message: "Pin is required" })
    .min(6, "Enter a valid Pin Code"),
});
